import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="container-custom py-12">
      <h1 className="text-3xl font-bold text-snudefryd-blue mb-8">Privatlivspolitik</h1>
      
      <div className="prose prose-lg max-w-none">
        <p className="lead mb-6">
          Hos Snudefryd tager vi beskyttelsen af dine personlige oplysninger alvorligt. Denne privatlivspolitik beskriver, hvordan vi indsamler, bruger og beskytter dine data.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Dataansvarlig</h2>
        <p>
          Snudefryd er dataansvarlig for behandlingen af de personoplysninger, som vi har modtaget om dig. Hvis du har spørgsmål til vores behandling af dine personoplysninger, er du altid velkommen til at kontakte os.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Hvilke oplysninger indsamler vi?</h2>
        <p>Vi indsamler og behandler følgende typer af personoplysninger:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Kontaktoplysninger (navn, e-mail, telefonnummer)</li>
          <li>Oplysninger om din hund (navn, race, alder, sundhedstilstand)</li>
          <li>Oplysninger i forbindelse med konsultationer og rådgivning</li>
          <li>Oplysninger i forbindelse med tilmelding til nyhedsbrev</li>
          <li>Oplysninger om din brug af vores hjemmeside via cookies</li>
        </ul>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Formål med behandlingen</h2>
        <p>Vi behandler dine personoplysninger til følgende formål:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>At levere vores ydelser og services til dig</li>
          <li>At kommunikere med dig om konsultationer og rådgivning</li>
          <li>At sende dig nyhedsbreve, hvis du har tilmeldt dig</li>
          <li>At forbedre vores hjemmeside og services</li>
          <li>At overholde lovgivningsmæssige krav</li>
        </ul>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Retsgrundlag for behandlingen</h2>
        <p>Vi behandler dine personoplysninger på følgende grundlag:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Dit samtykke</li>
          <li>Opfyldelse af en kontrakt med dig</li>
          <li>Vores legitime interesser, som ikke tilsidesætter dine interesser</li>
          <li>Overholdelse af retlige forpligtelser</li>
        </ul>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Opbevaring af dine personoplysninger</h2>
        <p>
          Vi opbevarer dine personoplysninger så længe det er nødvendigt for at opfylde de formål, til hvilke dine oplysninger er indsamlet. Oplysninger i forbindelse med konsultationer opbevares i op til 5 år efter sidste konsultation. Oplysninger til nyhedsbrev opbevares, indtil du afmelder dig.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Dine rettigheder</h2>
        <p>Du har følgende rettigheder i forhold til vores behandling af dine personoplysninger:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Ret til at se oplysninger (indsigtsret)</li>
          <li>Ret til berigtigelse (rettelse)</li>
          <li>Ret til sletning</li>
          <li>Ret til begrænsning af behandling</li>
          <li>Ret til dataportabilitet</li>
          <li>Ret til indsigelse</li>
          <li>Ret til at trække samtykke tilbage</li>
        </ul>
        <p>
          Du kan gøre brug af dine rettigheder ved at kontakte os på vores kontaktoplysninger angivet nederst i denne politik.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Cookies</h2>
        <p>
          Vi bruger cookies på vores hjemmeside til at forbedre brugeroplevelsen og indsamle statistik om brugen af hjemmesiden. Du kan læse mere om vores brug af cookies i vores cookiepolitik.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Klage til Datatilsynet</h2>
        <p>
          Hvis du er utilfreds med vores behandling af dine personoplysninger, kan du klage til Datatilsynet. Du finder Datatilsynets kontaktoplysninger på <a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer" className="text-snudefryd-blue hover:underline">www.datatilsynet.dk</a>.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Ændringer til privatlivspolitikken</h2>
        <p>
          Vi forbeholder os ret til at opdatere denne privatlivspolitik. Ved væsentlige ændringer vil vi informere dig via e-mail eller med en meddelelse på vores hjemmeside.
        </p>
        
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Kontakt</h2>
        <p>
          Hvis du har spørgsmål eller kommentarer til denne privatlivspolitik, er du velkommen til at kontakte os på:
        </p>
        <p className="mt-2">
          <strong>Snudefryd</strong><br />
          E-mail: erica@snudefryd.dk<br />
          Telefon: +45 51 97 16 42

        </p>
        
        <p className="mt-8 text-sm text-gray-500">
          Sidst opdateret: {new Date().toLocaleDateString('da-DK')}
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage; 